import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  CircularProgress,
} from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";
import { Backdrop } from "@material-ui/core";

import getParameterByName from "../../../../Functions/functions";

const ProceedBtn = ({
  open,
  close,
  submit,
  attachInvoiceLoading,
  formState,
  message
}) => {
  const roleName = getParameterByName("roleName");
  return (
    <Dialog open={open} onClose={close} fullWidth={true}>
      <DialogContent>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={attachInvoiceLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}>
          <HelpOutline color="secondary" fontSize="large" mt={2} />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
          p={2}
          mt={1}>
          {message ? (
            <Typography variant="h4" style={{ width: "80%" }}>
              {message}
            </Typography>
          ) : (
            <Typography variant="h4" style={{ width: "80%" }}>
              {formState?.isDraft
                ? "Are you sure you want to Save Your invoice as Draft with provided details?"
                : formState?.isProceed
                ? "Are You Sure you want to proceed next with the provided details"
                : (formState?.buyer||formState?.prInitiator)
                ? "Are you sure you want to send invoice to buyer / PR Initiator"
                : formState?.prInitiator
                ? "Are you sure you want to send invoice to PR Initiator"
                : (roleName === "Tax Team" || roleName === "AP Manager" || roleName === "AP GM")
                ? "Are You Sure you want to proceed next with the provided details"
                : "Are you sure you want to create invoice with the provided details?"}
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
          m={1}>
          <Button variant="outlined" color="secondary" onClick={close}>
            NO
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={submit}
            style={{ marginLeft: "20px" }}>
            Yes
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ProceedBtn;
